<template>

  <main class="content" v-if="typeof user.uuid !== 'undefined'">

    <div class="content__heading">
      <h1>
        <i class="icon--plans"></i> {{ $t('payment.title') }}
      </h1>
    </div>

    <section class="content--boxed">

      <ValidationObserver ref="form" #default="{ dirty, valid }">

        <template  v-if="plans.subscription === null">
          {{ $t('payment.description') }}
        </template>

        <div class="plans">
          <template v-for="item in plans.year">
            <div class="plans__plan" v-if="plans.subscription === null || item.name === plans.subscription" :class="{'plans__selected' : plans.subscription === item.name}" :key="item.name" >
            <div class="plans__popular" v-if="item.name === popularPlan">
              <div>
                <div>{{ $t('payment.popular') }}</div>
              </div>

            </div>

            <div class="plans__heading">
              <h2>{{ item.displayName }}</h2>
            </div>
            <div class="plans__body">
              <!-- {{ item.description }}-->

              <ul class="plans__perks">
                <li><span v-if="item.users">{{ item.users }}</span><span v-else>{{ $t('payment.unlimited') }}</span> {{
                  $t('general.users') }}
                </li>
                <li><span v-if="item.fuseboxes">{{ item.fuseboxes }}</span><span
                  v-else>{{ $t('payment.unlimited') }}</span> {{ $t('payment.fuseboxes') }}
                </li>
                <li :class="{'plans__perks--notPresent' : !item.permissions.request_access}">{{
                  $t('payment.requestAccess') }}
                </li>
                <li :class="{'plans__perks--notPresent' : !item.permissions.partner_listing}">
                  <span v-if="item.name === enterprisePlan">{{ $t('payment.exclusivePartnerlisting') }}</span><span v-else>{{ $t('payment.partnerlisting') }}</span>
                  (<span v-if="item.partnerListDistance > 0">{{ item.partnerListDistance }}</span><span

                    v-else>{{ listingDistance }}</span> {{ unit + ' ' + $t('payment.radius') }})
                </li>
                <li :class="{'plans__perks--notPresent' : !item.permissions.address_details_pdf}">{{
                  $t('payment.addressOnPdf') }}
                </li>
                <li :class="{'plans__perks--notPresent' : !item.permissions.logo_pdf}">{{ $t('payment.logoOnPdf') }}
                </li>
                <li :class="{'plans__perks--notPresent' : !item.permissions.email_pdf_client}">{{
                  $t('payment.emailPdfToClient') }}
                </li>
              </ul>

            </div>
            <div class="plans__pricing">
              {{ currency + ' ' + item.price }}
<!--              <template v-if="parseFloat(plans.vat) > 0">+ {{
                (parseFloat(item.price)*parseFloat(plans.vat)/100).toFixed(2) }}(VAT)
              </template>-->
              <small>{{ $t('payment.planTerm') }}</small>
<!--              <small v-if="parseFloat(plans.vat) <= 0">{{ $t('payment.planVAT') }}</small>-->
              <small>{{ $t('payment.planVAT') }}</small>
              <small v-if="item.name === plans.subscription">{{  $t('payment.planEnd') + ' ' }}{{ plans.subscriptionEndDate | moment('MMM D YYYY') }}</small>
              <small v-if="item.name === plans.subscription">{{  $t('payment.cancelEnable') + ' ' }}{{ cancelEnableAt }}</small>
            </div>
            <div class="plans__buttons">
              <button v-if="plans.subscription === null" type="button" class="btn"
                      @click="$modal.show('confirmation'), setPlan(item.name)">
                <i class="icon--check"></i> {{ $t('payment.selectPlan') }}
              </button>
              <button v-if="plans.subscription === item.name" @click="$modal.show('cancel')" class="btn">
                <i class="icon--cancel"></i> {{ $t('payment.cancelPlan') }}
              </button>

            </div>
          </div>
          </template>
        </div>

      </ValidationObserver>

    </section>

    <section class="content--boxed">
      <div class="content--boxed__heading">
        <h2><i class="icon--invoice"></i> {{ $t('payment.invoices') }}</h2>
      </div>
      <!--   Showing only invoice for the current plan   -->
      <div class="table table--badged" v-if="transactions.length > 0">

        <div class="table--badged__row" :class="[transaction.ends_at ? 'disabled' : '']" :key="transaction.id"
             v-for="transaction in transactions">

          <div class="table--badged__badge" data-icon="Invoice"></div>
          <div class="table--badged__description">
            <h3>
              #{{ transaction.number }}: {{ $t(`payment.plan.${transaction.plan}`) }} ({{ transaction.cycle_started_at |
              moment('MMM YYYY') }} - {{ transaction.cycle_ends_at | moment('MMM YYYY') }})
            </h3>
            <small>

              <span class="table--badged__description__item">
                <i class="icon--calendar"></i> {{ transaction.processed_at | moment('MMM D YYYY, HH:mm') }}</span>
              <span class="table--badged__description__item">
                 {{ transaction.total }}
              </span>
            </small>
          </div>
          <div class="navigation--buttonGroup navigation--buttonGroup--table">

            <button @click="downloadInvoice(transaction.number)"><i class="icon--pdf"></i>
            </button>
          </div>

        </div>

      </div>
      <div class="message" v-else>
        {{ $t('payment.noInvoices') }}
      </div>

    </section>

    <Confirm body="payment.confirmation" action-key="payment.confirm" @confirmed="submitForm"/>
    <Confirm name="cancel" body="payment.cancelConfirmation" action-key="payment.confirm" @confirmed="cancelPlan"
             title="payment.cancelConfirmTitle"/>

  </main>
</template>

<script>
import { APP_CURRENCY, HTTP_CODE, UNIT_LENGTH, POPULAR_PLAN, ENTERPRISE_PLAN } from '@/constants'
import { errHandler } from '@/helpers'
import Confirm from '@/components/Modal/Confirm'

export default {
  name: 'Payment-Index',
  components: { Confirm },
  beforeMount () {
    this.$store.commit('loader/startIntLoading')
  },
  mounted () {
    this.init(true)
  },
  data: () => {
    return {
      period: 1,
      currency: APP_CURRENCY,
      // default to display
      listingDistance: 10,
      unit: UNIT_LENGTH,
      submit: false,
      popularPlan: POPULAR_PLAN,
      enterprisePlan: ENTERPRISE_PLAN
    }
  },
  computed: {
    paymentData () {
      return this.$store.getters['payment/paymentData']
    },
    plans () {
      return this.$store.getters['payment/plans']
    },
    transactions () {
      return this.$store.getters['payment/transactions']
    },
    cancelEnableAt () {
      return this.$moment(this.plans.subscriptionEndDate).subtract(6, 'd').format('MMM D YYYY')
    }
  },
  methods: {
    async init (resetPage = false) {
      try {
        await this.$store.dispatch('payment/getPlans')
        await this.$store.dispatch('payment/getTransactions')
        this.displayPlans = this.plans.year
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      } finally {
        this.$store.dispatch('loader/stopIntLoading')
      }
    },
    async submitForm () {
      try {
        await this.$store.dispatch('payment/subscribe', { 'name': this.selectedPlan })
        if (this.paymentData.redirect !== null) {
          window.location = this.paymentData.redirect
        }
        this.init()
        this.$modal.hide('confirmation')
        if (this.paymentData.success !== null) {
          this.$toasted.global.success_message({
            message: this.paymentData.success
          })
        }
        if (this.paymentData.error !== null) {
          this.$toasted.global.error_message({
            message: this.paymentData.error
          })
        }
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    },
    setPlan (name) {
      this.selectedPlan = name
    },
    async cancelPlan () {
      if (this.submit) { return false }
      try {
        this.submit = true
        await this.$store.dispatch('payment/cancelPlan')
        this.init()
        this.$modal.hide('cancel')
        this.$toasted.global.success_message({
          message: this.$t('payment.cancelSuccess')
        })
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
        if (typeof e.response !== 'undefined') {
          if (e.response.status === HTTP_CODE.UNPROCESSABLE_ENTITY) {
            this.$modal.hide('cancel')
          }
        }
      } finally {
        this.submit = false
      }
    },
    async downloadInvoice (orderId) {
      try {
        const data = await this.$store.dispatch('payment/invoiceGenerate', orderId)
        const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Invoice-${orderId}.pdf`)
        document.body.appendChild(link)
        link.click()
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    }
  }
}
</script>
